import React, { useState } from 'react'
import { Modal, Radio, Button } from "antd";
import { message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
const ExportModalNotification = ({ visible, onClose }) => {


    const [format, setFormat] = useState("csv");
    
      const handleExport = () => {
        console.log("Exporting as:", format);
        const key = "exportMessage";
        message.open({
        key,
        content: (
          <div className="custom-message-content">
          <span>Certifications Export successful!</span>
          <CloseOutlined
            className="custom-message-close"
            onClick={() => message.destroy(key)}
          />
        </div>
        ),
        duration: 3,
         
      });
        onClose();
      };

  return (
    <Modal
          open={visible}
          onCancel={onClose}
          footer={null}
          centered
          width={400}
          className="export-modal"
        >
          <h2 className="export-title">Export List</h2>
          <p className="export-description">
            You are exporting <strong>112 certifications</strong>{" "}
            <span className="filtered-text">(Filtered: Due in 7 Days)</span>
          </p>
    
          <div className="export-options">
            <label className="export-label">Choose Format</label>
            <Radio.Group
              onChange={(e) => setFormat(e.target.value)}
              value={format}
              className="export-radio-group"
            >
              <Radio value="csv" className="radio-group-label">CSV</Radio>
              <Radio value="excel" className="radio-group-label">Excel (XLSX)</Radio>
              <Radio value="pdf" className="radio-group-label">PDF</Radio>
            </Radio.Group>
          </div>
    
          <div className="export-footer">
            <Button onClick={onClose} className="export-btn export-cancel-btn">Cancel</Button>
            <Button type="primary" onClick={handleExport} className="export-btn">
              Export
            </Button>
          </div>
        </Modal>
  )
}

export default ExportModalNotification
